import { uid } from "../create-shared";
import type { SpacerBlock } from "../types";
import type { BlockDefinition } from "./types";

export function createSpacerBlock(height = 24): SpacerBlock {
  return {
    id: uid(),
    type: 'spacer',
    height,
  };
}

export const spacerBlockDefinition: BlockDefinition = {
  type: 'spacer',
  label: 'Spacer',
  create: () => createSpacerBlock(),
};
